import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import bibleIcon from '../images/image.png';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        <div className="header-content">
          <img src={bibleIcon} alt="Bible Bro" className="header-logo" />
          <h1 className="header-title">Bible Bro</h1>
        </div>
        <p className="header-subtitle">Your Daily Bible Companion</p>
        <nav className="header-nav">
          <Link to="/terms" className="header-nav-link">Terms of Service</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-image-container">
            <img src={bibleIcon} alt="Bible Bro Character" className="hero-image" />
          </div>
          <h2 className="hero-title">Deepen Your Faith, One Day at a Time</h2>
          <p className="hero-description">
            Bible Bro is your comprehensive Bible study companion, featuring AI-powered chat, 
            interactive quizzes, and daily Scripture readings to help you grow in your faith journey.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div className="feature-cross">✝</div>
              <h3 className="feature-title">Chat with Bible Bro</h3>
              <p className="feature-description">
                Have meaningful conversations with our AI-powered Christian chatbot. 
                Get answers to your Bible questions, receive encouragement, and deepen 
                your understanding of Scripture.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 9H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2m6-8h2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2m-6 0H6m6 0v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2m8-10V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v4" />
                </svg>
              </div>
              <div className="feature-cross">✝</div>
              <h3 className="feature-title">Bible Quiz</h3>
              <p className="feature-description">
                Test your knowledge with thousands of Bible quiz questions covering 
                various books, themes, and topics. Track your progress and challenge 
                yourself to grow in biblical understanding.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                </svg>
              </div>
              <div className="feature-cross">✝</div>
              <h3 className="feature-title">Daily Bible Reading</h3>
              <p className="feature-description">
                Engage with Scripture through structured daily readings. Build a 
                consistent habit of Bible study and reflection with our comprehensive 
                reading plans and progress tracking.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cross-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v20M2 12h20" strokeLinecap="round"/>
              </svg>
            </div>
            <h2 className="cta-title">Start Your Faith Journey Today</h2>
            <p className="cta-description">
              Download Bible Bro and begin your daily walk with God through Scripture, 
              prayer, and study.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © {new Date().getFullYear()} Astrid Genesis LLC. All rights reserved.
            </p>
            <div className="footer-links">
              <Link to="/terms" className="footer-link">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;

